// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { GroupFacadeService } from './../../../state/groups/group.facade';
import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Loaded, Loadable, readParameterFromRouterState, UserService, BackAction } from '@app/core';
import { ActivatedRoute } from '@angular/router';
import { UserDetailsFacadeService } from '@app/access-management/state/user-details/user-details.facade';
import { UserState, UserGroupsCreateRequest } from '@app/access-management/state/user-details/user-details.interfaces';
import { Group } from '@app/access-management/core/models/groups.model';
import { filter, map } from 'rxjs/operators';
import { SelectedRows } from '@app/shared/data-table-ajax/data-table-ajax.component';
import { AlertService } from '@app/core/services/alert.service';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-user-details-groups-tab-add',
    templateUrl: './user-details-groups-tab-add.component.html'
})
export class UserDetailsGroupsTabAddComponent {
    user$: Observable<UserState> | undefined;

    groupTableColumns = [
        {
            name: 'Group Name',
            prop: 'group_name',
            flexGrow: 2
          },
          {
            name: 'Description',
            prop: 'description',
            flexGrow: 2
          }
    ];

    currentUser: UserState | undefined;
    groups$: Observable<Loaded<Group[]> | Loadable> | undefined;
    selectedGroups: any[] = [];
    userGroups$: any;

    constructor(
        private store: Store<any>,
        private userDetailsFacade: UserDetailsFacadeService,
        private userService: UserService,
        private groupFacade: GroupFacadeService,
        private alertService: AlertService,
        private activatedRoute: ActivatedRoute
    ) {

        const username = readParameterFromRouterState(this.activatedRoute, 'username');
        if (!username) {
          throw new Error('User id not in route');
        }

        this.userDetailsFacade.initialize(username);
        this.user$ = this.userDetailsFacade.user$;

        this.user$.subscribe((user) => {
          this.currentUser = user;
        });

        this.groupFacade.initializeGroup();
        this.groups$ = this.groupFacade.groups$.pipe(
            filter((state: any) => !!state && !!state.data),
            map((state: any) => state.data)
        );

        this.userGroups$ = this.userService.getUserGroups(username);
    }

    onSelectGroups (rows: any) {
        this.selectedGroups = rows;
    }

    onSelectRows(rows: SelectedRows) {
        this.selectedGroups = rows.selected;
    }

    addGroups() {
        if (!this.currentUser) {
            return;
        }

        const request: UserGroupsCreateRequest = {
            group_ids: this.selectedGroups.map(row => row.group_id)
        };

        this.userService.addGroupsToUser(this.currentUser.username, request)
            .subscribe(() => this.addGroupsSucceed(), () => this.addGroupsFailed());
    }
    addGroupsSucceed () {
        this.store.dispatch(new BackAction());
        this.alertService.success('Add Groups to user succeed');
    }
    addGroupsFailed() {
        this.alertService.error('Add Groups to User failed');
    }
}



// WEBPACK FOOTER //
// ./src/app/access-management/users/user-details/user-details-groups-tab-add/user-details-groups-tab-add.component.ts